/* eslint-disable */
import React, { useEffect } from "react";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import type { FC, ChangeEvent } from "react";
import { createStyles } from "@material-ui/styles";
import { Theme, makeStyles } from "@material-ui/core";

import { FileFormat, SubscriptionItemType } from "../../types";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    group: {
      fontSize: "12px",
    },
    controlLabel: {
      "& span": {
        fontSize: "12px",
      },
      marginRight: theme.spacing(3),
    },
    control: {
      fontSize: "12px",
      "& svg": {
        fill: "#65ac1f",
      },
    },
  })
);

type SubscriptionsSettingsFileFormatProps = {
  value: FileFormat;
  onChange: (format: FileFormat) => void;
  type: SubscriptionItemType;
};

export const SubscriptionsSettingsFileFormat: FC<SubscriptionsSettingsFileFormatProps> = (props: SubscriptionsSettingsFileFormatProps) => {
  const { value, onChange, type } = props;
  const classes = useStyles();

  const handleChange = (e: ChangeEvent<{}>, value: string) => {
    onChange(Number(value));
  };

  return (
    <RadioGroup className={classes.group} row aria-label="position" name="position" value={value} onChange={handleChange}>
      <FormControlLabel
        className={classes.controlLabel}
        value={FileFormat.XLSX}
        control={<Radio color="primary" className={classes.control} />}
        label="XLSX"
      />
      <FormControlLabel
        className={classes.controlLabel}
        value={FileFormat.CSV}
        disabled={type === SubscriptionItemType.Slide}
        control={<Radio color="primary" className={classes.control} />}
        label="CSV"
      />
    </RadioGroup>
  );
};
